<template>
  <div class="DelayZoom" :style="{'animation-delay': delay + 'ms'}">

      <slot>
      </slot>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'

export default {
  name: 'DelayZoom',
  components: {
    //component
  },
  props: {
    delay: Number
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.DelayZoom{
  transform: scale(0);
  animation: scale 200ms ease-in;
  animation-fill-mode: forwards;
}

@-webkit-keyframes scale {
  from{
      transform: scale(0) rotate(20deg);
  }
  to{
      transform: scale(1);
  }
}

</style>
